/** This export is automatically generated */
export const isoNow = '2025-04-15T05:40:39.310Z';
